export default __webpack_public_path__ + "static/media/DunbarLow-Light.47d84be6.woff";